export const parserForTime = ({ hour, minute }) => {
    const minuteEd = minute < 30 ? '00' : '30'
    return `${hour}:${minuteEd}`
}
